// capitalize.ts
export const capitalize = (str: string): string => {
    if (!str) return '';
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  };
  
// capatalise the first letter of each word
export const titleCase = (str: string): string => {
  if (!str) return '';
    return str
      .split(' ')
      .map((word) => capitalize(word))
      .join(' ');
  };